exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-records-page[data-v-cc8e6e1e] {\n  width: 100%;\n  height: 100%;\n  padding: 1rem;\n}\n.list-records-page .page-title[data-v-cc8e6e1e] {\n  font-size: 32px;\n  font-weight: bold;\n  color: #0B486B;\n  margin-bottom: 1rem;\n}\n.list-records-page .header-bar[data-v-cc8e6e1e] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  gap: 1rem;\n}", ""]);

// exports
